module.exports = __webpack_public_path__ + "media/images/contract-83d8f2df94af6b4b1b239f1cf6c4671e.svg";